import { Navigate, Outlet } from 'react-router'
import { Box, CircularProgress } from '@mui/material'
import { useAuth } from '../auth/AuthContext.js'
import { Sidebar } from '../components/Sidebar.js'

export const AppLayout = () => {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" height="100vh">
        <CircularProgress />
      </Box>
    )
  }

  if (!user) return <Navigate to="/login" replace />

  return (
    <Box display="flex" height="100vh">
      <Sidebar />
      <Box flex={1} minWidth={0}>
        <Outlet />
      </Box>
    </Box>
  )
}
